module.exports = __webpack_public_path__ + "static/social-wolf-83ada5c07e0cd82e4e022afbbc820c39.jpg";